export default "__VITE_ASSET__CijGm9wZ__"